module.exports = __webpack_public_path__ + "img/gym-no.437b09dc.svg";